import { InsuranceType } from '@/models/insurance.ts';

export enum ChainAvailabilityStatus {
    AVAILABLE = 'AVAILABLE',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export type ChainAvailabilityItem = {
    step_order: number;
    appointment_type_id: string;
    appointment_type_key: string;
    calendar_id: string;
    start_date: string; // ISO datetime
    end_date: string; // ISO datetime
    status: ChainAvailabilityStatus;
};

export type ChainAvailabilityRequestStep = {
    step_order: number;
    pms_calendar_id: string;
};

export type ChainAvailabilityParams = {
    customer_id: string;
    insurance_type: InsuranceType;
    instance_id: string;
    chain_id: string;
    start_date: string; // YYYY-MM-DD
    journey_type: string;
    steps: ChainAvailabilityRequestStep[];
    main_practitioner_id?: string;
};

export type ChainAutoSuggestionRequestStep = {
    step_order: number;
    pms_calendar_id: string;
};

export type ChainAutoSuggestionParams = {
    customer_id: string;
    insurance_type: InsuranceType;
    is_returning: boolean;
    instance_id: string;
    chain_id: string;
    start_date?: string; // YYYY-MM-DD
    journey_type: string;
    steps: ChainAutoSuggestionRequestStep[];
    main_practitioner_id?: string;
};
